

/// <reference path="AccountingJournalLineFormulaTemplate.ts" />

// Generated class AccountingJournalEntryTemplate_ManagedObject

class AccountingJournalEntryTemplate_ManagedObject extends AccountingJournalLineFormulaTemplate
{

    // Property: entrySide
    set entrySide(value:number) {
        this.setValueForKey(value, 'entrySide');
    }
    get entrySide():number {
        return this.valueForKey('entrySide');
    }
    set entrySidePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'entrySide');
    }
    get entrySidePrimitiveValue():number {
        return this.primitiveValueForKey('entrySide');
    }

    // Property: generateAccountFromBase
    set generateAccountFromBase(value:boolean) {
        this.setValueForKey(value, 'generateAccountFromBase');
    }
    get generateAccountFromBase():boolean {
        return this.valueForKey('generateAccountFromBase');
    }
    set generateAccountFromBasePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'generateAccountFromBase');
    }
    get generateAccountFromBasePrimitiveValue():boolean {
        return this.primitiveValueForKey('generateAccountFromBase');
    }
    // Relationship: ledgerAccount
    set ledgerAccount(value:LedgerAccount) {
        this.setValueForKey(value, 'ledgerAccount');
    }
    get ledgerAccount():LedgerAccount {
        return this.valueForKey('ledgerAccount') as LedgerAccount;
    }
}
